import { domPropsSelector } from '.';
import useDomProps from '../../../../store/selection/useDomProps';
import { useResponsiveTableContext } from './ResponsiveTableContext';

const SeparatorCell = ({
  colSpan,
  rowIndex,
}: {
  colSpan: number;
  rowIndex: number;
}) => {
  const { name } = useResponsiveTableContext();
  const domProps = useDomProps(
    'separator',
    { rowIndex },
    domPropsSelector(name),
  );
  return (
    <td className="row__separator__cell" colSpan={colSpan} {...domProps} />
  );
};

export default SeparatorCell;
